import React from 'react';
import { Input, Button, Textarea, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { connect } from 'react-redux';
import { UserService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalBank extends React.Component<Props> {

	is_vzla = this.props.item?.country_id == Constants.COUNTRIES.VZLA;

	state = {
		banks: [],
		phonecodes: [],
		document_types: [],
		form: {
			payment_mobile_document_type_id: '',
			payment_mobile_document: '',
			payment_mobile_phonecode_id: '',
			payment_mobile_phone: '',
			payment_mobile_bank_id: '',
			bank_account_number: '',
			bank_type_account: '',
			bank_account_name: '',
			bre_b_key: '',
			bre_b_type_id: '',
			bank_data_type: Constants.BANK_DATA_TYPE.TRANSFER
		},
		bre_b_types: []
	}

	componentDidMount() {
		const person = this.props.item?.person;
		if (person) {
			this.setState({
				form: {
					...this.state.form,
					payment_mobile_document_type_id: person?.payment_mobile_document_type_id || '',
					payment_mobile_document: person?.payment_mobile_document || '',
					payment_mobile_phonecode_id: person?.payment_mobile_phonecode_id || '',
					payment_mobile_phone: person?.payment_mobile_phone || '',
					payment_mobile_bank_id: person?.payment_mobile_bank_id || '',
					bank_account_number: person?.bank_account_number || '',
					bank_account_name: person?.bank_account_name || '',
					bank_type_account: person?.bank_type_account || '',
					bre_b_key: person?.bre_b_key || '',
					bre_b_type_id: person?.bre_b_type_id || '',
					bank_data_type: person?.bank_data_type || Constants.BANK_DATA_TYPE.TRANSFER
				}
			});
		}

		this.load();
	}

	load = async () => {
		const res: any = await UserService.admin.getBanks({
			user_id: this.props.item?.id
		});
		this.setState({
			banks: res.banks || [],
			document_types: res.document_types || [],
			phonecodes: res.phonecodes || [],
			bre_b_types: res.bre_b_types || []
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		await UserService.admin.updateBankData({
			user_id: this.props.item?.id,
			...this.state.form
		});
		this.props.onClose();
		Globals.showSuccess("Se ha actualizado los datos bancarios");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<form id="modal-view-bank" onSubmit={ this.submit }>
				<div className="row">
					{
						!this.is_vzla && (
							<div className="col-md-12">
								<Select
									disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
									placeholder="Seleccionar"
									label="Transferencia o Bre-B"
									name="bank_data_type"
									onChange={ (e: any) => this.change(e) }
									value={ this.state.form.bank_data_type }
									options={ [
										{ value: Constants.BANK_DATA_TYPE.TRANSFER.toString(), label: 'Transferencia' },
					              		{ value: Constants.BANK_DATA_TYPE.BRE_B.toString(), label: 'Bre-B' },
									] } />
							</div>
						)
					}

					{
						(this.is_vzla || this.state.form.bank_data_type == Constants.BANK_DATA_TYPE.TRANSFER) && (
							<>
								{
									this.is_vzla && (
										<>
											<div className="col-md-3">
												<Select
													disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
													placeholder="Seleccionar"
													label="Código"
													name="payment_mobile_phonecode_id"
													onChange={ (e: any) => this.change(e) }
													value={ this.state.form.payment_mobile_phonecode_id }
													options={ this.state.phonecodes.map((item: any) => {
														return {
															value: item.id,
															label: item.name
														}
													}) } />
											</div>
											<div className="col-md-9">
												<Input
													disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
													type="number"
													value={ this.state.form.payment_mobile_phone }
													name="payment_mobile_phone"
													label="Teléfono"
													maxLength={ 7 }
													onChange={ this.change } />
											</div>
										</>
									)
								}
								{
									this.is_vzla && (
										<div className="col-md-3">
											<Select
												disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
												placeholder="Seleccionar"
												label="Tipo"
												name="payment_mobile_document_type_id"
												onChange={ (e: any) => this.change(e) }
												value={ this.state.form.payment_mobile_document_type_id }
												options={ this.state.document_types.filter((i: any) => i.id == Constants.DOCUMENT_TYPES.V || i.id == Constants.DOCUMENT_TYPES.E).map((item: any) => {
													return {
														value: item.id,
														label: item.name
													}
												}) } />
										</div>
									)
								}
								<div className={ `col-md-${ this.is_vzla ? '9' : '6' }` }>
									<Input
										disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
										type="number"
										value={ this.state.form.payment_mobile_document }
										name="payment_mobile_document"
										label="Cédula"
										maxLength={ this.is_vzla ? 8 : 11 }
										onChange={ this.change } />
								</div>
								{
									!this.is_vzla && (
										<div className="col-md-6">
											<Select
												disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
												placeholder="Seleccionar"
												label="Tipo de cuenta"
												name="bank_type_account"
												onChange={ (e: any) => this.change(e) }
												value={ this.state.form.bank_type_account }
												options={ [
													{ value: Constants.BANK_ACCOUNT_TYPES.SAVINGS.toString(), label: 'Cuenta de Ahorro' },
											        { value: Constants.BANK_ACCOUNT_TYPES.CHECKING.toString(), label: 'Cuenta Corriente'}
												] } />
										</div>
									)
								}
								<div className="col-md-6">
									<Select
										disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
										placeholder="Seleccionar"
										label="Banco"
										name="payment_mobile_bank_id"
										onChange={ (e: any) => this.change(e) }
										value={ this.state.form.payment_mobile_bank_id }
										options={ this.state.banks.map((item: any) => {
											return {
												value: item.id,
												label: item.name
											}
										}) } />
								</div>
								<div className="col-md-6">
									<Input
										disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
										type="number"
										value={ this.state.form.bank_account_number }
										name="bank_account_number"
										label="Número de cuenta bancaria"
										maxLength={ 20 }
										onChange={ this.change } />
								</div>
							</>
						)
					}

					{
						!this.is_vzla && this.state.form.bank_data_type == Constants.BANK_DATA_TYPE.BRE_B && (
							<>
								<div className="col-md-6">
									<Select
										disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
										placeholder="Seleccionar"
										label="Tipo de llave"
										name="bre_b_type_id"
										onChange={ (e: any) => this.change(e) }
										value={ this.state.form.bre_b_type_id }
										options={ this.state.bre_b_types?.map((item: any) => {
							              	return {
							              		value: item?.id,
							              		label: item?.name
							              	}
							            }) } />
								</div>
								<div className="col-md-6">
									<Input
										disabled={ !checkPermission(Constants.MODULES.USERS,'write') }
										value={ this.state.form.bre_b_key }
										name="bre_b_key"
										label="Llave de Bre-B"
										onChange={ this.change } />
								</div>
							</>
						)
					}
				</div>
				{
					checkPermission(Constants.MODULES.USERS,'write') && (
						<div className="text-center">
							<Button type="submit" className="btn-save">
								Guardar
							</Button>
						</div>
					)
				}
			</form>
		)
	}
}

export default ModalBank;